// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-form-field {
    width: 100%;
    margin: 10px auto;
  }`, "",{"version":3,"sources":["webpack://./src/app/+home/+my-libraries/+sites/document-library/shared/dialog-export-folder/dialog-export-folder.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;EACnB","sourcesContent":["mat-form-field {\r\n    width: 100%;\r\n    margin: 10px auto;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
